/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Championship points are different from fantasy points. A driver can win the championship but still be a poor fantasy pick if their price is too high relative to their scoring. Use Standings to follow the real championship, and Fantasy Points to see how drivers score in the game.`)
};

const es_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los puntos del campeonato son diferentes de los puntos de fantasy. Un piloto puede ganar el campeonato pero ser una mala elección de fantasy si su precio es demasiado alto en relación con su puntuación. Usa la Clasificación para seguir el campeonato real y Fantasy Points para ver cómo puntúan los pilotos en el juego.`)
};

const de_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WM-Punkte unterscheiden sich von Fantasy-Punkten. Ein Fahrer kann die Meisterschaft gewinnen, aber trotzdem ein schlechter Fantasy-Pick sein, wenn sein Preis im Verhältnis zu seiner Wertung zu hoch ist. Nutze die Wertung, um die echte Meisterschaft zu verfolgen, und Fantasy Points, um zu sehen, wie Fahrer im Spiel punkten.`)
};

const nl_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampioenschapspunten verschillen van fantasy-punten. Een coureur kan het kampioenschap winnen maar toch een slechte fantasy-keuze zijn als zijn prijs te hoog is ten opzichte van zijn score. Gebruik de Stand om het echte kampioenschap te volgen en Fantasy Points om te zien hoe coureurs in het spel scoren.`)
};

const fr_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les points du championnat diffèrent des points fantasy. Un pilote peut gagner le championnat tout en étant un mauvais choix fantasy si son prix est trop élevé par rapport à son scoring. Utilisez le Classement pour suivre le vrai championnat, et Fantasy Points pour voir comment les pilotes scorent dans le jeu.`)
};

const it_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I punti del campionato sono diversi dai punti fantasy. Un pilota può vincere il campionato ma essere comunque una scelta fantasy mediocre se il suo prezzo è troppo alto rispetto al suo punteggio. Usa la Classifica per seguire il campionato reale e Fantasy Points per vedere come i piloti punteggiano nel gioco.`)
};

const pt_br2_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pontos do campeonato são diferentes dos pontos fantasy. Um piloto pode ganhar o campeonato mas ainda ser uma escolha ruim no fantasy se o preço dele for muito alto em relação à pontuação. Use a Classificação para acompanhar o campeonato real e Fantasy Points para ver como os pilotos pontuam no jogo.`)
};

const pt_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pontos do campeonato são diferentes dos pontos fantasy. Um piloto pode ganhar o campeonato mas ser uma má escolha fantasy se o seu preço for demasiado alto em relação à sua pontuação. Use a Classificação para seguir o campeonato real e Fantasy Points para ver como os pilotos pontuam no jogo.`)
};

const ja_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャンピオンシップポイントとファンタジーポイントは異なります。ドライバーがチャンピオンシップを勝っても、価格がスコアに対して高すぎる場合、ファンタジーでは悪い選択になることがあります。順位表で実際のチャンピオンシップを追跡し、Fantasy Pointsでゲーム内のスコアを確認しましょう。`)
};

const zh_f1_standings_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锦标赛积分与梦幻积分不同。一位车手可能赢得锦标赛，但如果其价格相对于得分过高，在梦幻游戏中可能是个糟糕的选择。使用积分榜追踪真实锦标赛，使用Fantasy Points查看车手在游戏中的得分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_how_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_how_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_how_p2", locale)
	if (locale === "en") return en_f1_standings_how_p2(inputs)
	if (locale === "es") return es_f1_standings_how_p2(inputs)
	if (locale === "de") return de_f1_standings_how_p2(inputs)
	if (locale === "nl") return nl_f1_standings_how_p2(inputs)
	if (locale === "fr") return fr_f1_standings_how_p2(inputs)
	if (locale === "it") return it_f1_standings_how_p2(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_how_p2(inputs)
	if (locale === "pt") return pt_f1_standings_how_p2(inputs)
	if (locale === "ja") return ja_f1_standings_how_p2(inputs)
	return zh_f1_standings_how_p2(inputs)
};